import React from "react";
import { Link, Typography } from "@mui/material";
import { navigate } from "gatsby";
import ExclamationMark from "../../assets/svgs/loan/exclamationMark.svg";
import LoanApplicationLayout from "../../components/soknad/LoanApplicationLayout";
import MessageBox from "../../components/soknad/MessageBox";
import COLORS from "../../constants/colors";
import SEO from "../../components/Seo";

const KredrittSperret = () => {
  return (
    <LoanApplicationLayout>
      <MessageBox
        imageSvg={<ExclamationMark height="150px" />}
        title="Du har aktivert kredittsperre hos Bislab."
        description="Aktivert kredittsperre gir automatisk avslag fra banker som benytter Bislabs tjenester for kredittvurdering. "
        buttons={[
          <Link
            key={1}
            target="_blank"
            href="https://bislab.no"
            color="primary"
            variant="label"
          >
            Fjern kredittsperre hos Bislab{" "}
          </Link>,
          <Typography
            variant="label"
            sx={{
              textAlign: "center",
            }}
            color="blue.main"
            key={2}
            onClick={() => {
              // TODO should change to some replace method

              navigate("/soknad");
            }}
          >
            Avbryt søknad
          </Typography>,
        ]}
      />
    </LoanApplicationLayout>
  );
};

export default KredrittSperret;

export function Head() {
  return (
    <SEO
      title="Kredittsperre"
      description="Side som viser informasjon om at du har kredittsperret deg."
    />
  );
}
